import {
  water_mark_3_lines_default
} from "./chunk-ERSSYS5Z.js";
import {
  water_mark_monogram_default
} from "./chunk-URY6IS2R.js";
import {
  burger_default
} from "./chunk-LRNRW542.js";
import {
  calendar_default
} from "./chunk-6P3MY3QC.js";
import {
  close_default
} from "./chunk-OQ6YPE2G.js";
import {
  logo_default
} from "./chunk-LIRKC5BU.js";
import {
  pause_default
} from "./chunk-NFB5BG3M.js";
import {
  play_default
} from "./chunk-Q6PP23HX.js";
import {
  water_mark_1_line_default
} from "./chunk-DKFUGCYN.js";
import {
  water_mark_2_lines_default
} from "./chunk-2GPVSVKP.js";
import {
  arrow_short_default
} from "./chunk-G43F2VEB.js";
import {
  arrow_default
} from "./chunk-IRKKTJ4B.js";

// src/blocks/icon/icon.tsx
import { jsx } from "react/jsx-runtime";
var Icon = ({
  className,
  SVGClassName = "",
  id,
  name,
  ...rest
}) => {
  if (!name) return null;
  let IconComponent = null;
  switch (name) {
    case "arrow-left":
      IconComponent = /* @__PURE__ */ jsx(arrow_default, { ...rest, className: SVGClassName, direction: "left" });
      break;
    case "arrow-up":
      IconComponent = /* @__PURE__ */ jsx(arrow_default, { ...rest, className: SVGClassName, direction: "up" });
      break;
    case "arrow-down":
      IconComponent = /* @__PURE__ */ jsx(arrow_default, { ...rest, className: SVGClassName, direction: "down" });
      break;
    case "arrow-right":
      IconComponent = /* @__PURE__ */ jsx(arrow_default, { ...rest, className: SVGClassName, direction: "right" });
      break;
    case "arrow-top-right":
      IconComponent = /* @__PURE__ */ jsx(arrow_default, { ...rest, className: SVGClassName, direction: "top-right" });
      break;
    case "arrow-short-left":
      IconComponent = /* @__PURE__ */ jsx(arrow_short_default, { ...rest, className: SVGClassName, direction: "left" });
      break;
    case "arrow-short-up":
      IconComponent = /* @__PURE__ */ jsx(arrow_short_default, { ...rest, className: SVGClassName, direction: "up" });
      break;
    case "arrow-short-down":
      IconComponent = /* @__PURE__ */ jsx(arrow_short_default, { ...rest, className: SVGClassName, direction: "down" });
      break;
    case "arrow-short-right":
      IconComponent = /* @__PURE__ */ jsx(arrow_short_default, { ...rest, className: SVGClassName, direction: "right" });
      break;
    case "arrow-short-top-right":
      IconComponent = /* @__PURE__ */ jsx(
        arrow_short_default,
        {
          ...rest,
          className: SVGClassName,
          direction: "top-right"
        }
      );
      break;
    case "burger":
      IconComponent = /* @__PURE__ */ jsx(burger_default, { ...rest, className: SVGClassName });
      break;
    case "close":
      IconComponent = /* @__PURE__ */ jsx(close_default, { ...rest, className: SVGClassName });
      break;
    case "calender":
      IconComponent = /* @__PURE__ */ jsx(calendar_default, { ...rest, className: SVGClassName });
      break;
    case "play":
      IconComponent = /* @__PURE__ */ jsx(play_default, { ...rest, className: SVGClassName });
      break;
    case "pause":
      IconComponent = /* @__PURE__ */ jsx(pause_default, { ...rest, className: SVGClassName });
      break;
    case "logo":
      IconComponent = /* @__PURE__ */ jsx(
        logo_default,
        {
          className: `text-heritage-off-white-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-1-line-off-white":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_1_line_default,
        {
          className: `text-heritage-off-white-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-1-line-soft-black":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_1_line_default,
        {
          className: `text-heritage-soft-black-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-2-lines-off-white":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_2_lines_default,
        {
          className: `text-heritage-off-white-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-2-lines-soft-black":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_2_lines_default,
        {
          className: `text-heritage-soft-black-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-3-lines-off-white":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_3_lines_default,
        {
          className: `text-heritage-off-white-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-3-lines-soft-black":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_3_lines_default,
        {
          className: `text-heritage-soft-black-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-monogram-white":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_monogram_default,
        {
          className: `text-heritage-off-white-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    case "water-mark-monogram-black":
      IconComponent = /* @__PURE__ */ jsx(
        water_mark_monogram_default,
        {
          className: `text-heritage-soft-black-full ${SVGClassName}`,
          ...rest
        }
      );
      break;
    default:
      IconComponent = null;
      break;
  }
  if (!IconComponent) return null;
  return /* @__PURE__ */ jsx("span", { "aria-label": "hidden", className, id, children: IconComponent });
};
var icon_default = Icon;

export {
  Icon,
  icon_default
};
